function pinchZoom(imageElement) {
  const container = imageElement;
  const containerHeight = container.offsetHeight;
  const containerWidth = container.offsetWidth;
  const elementHeight = imageElement.offsetHeight;
  const elementWidth = imageElement.offsetWidth;

  let isZooming = false;
  const start = {};
  const maxScale = 4;
  const initial = {
    x: 0,
    y: 0,
    scale: 1,
  };
  const liveValues = {};

  // Calculate distance between two fingers
  const distance = (event) =>
    Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);

  const transformElement = (deltaX, deltaY, scale) => {
    const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${scale})`;
    imageElement.style.transform = transform;
    imageElement.style.WebkitTransform = transform;
    imageElement.style.zIndex = '9999';
  };

  let latestTap;
  const doubleTapZoom = (event) => {
    const now = new Date().getTime();
    const timesince = now - latestTap;
    if (timesince < 300 && timesince > 0) {
      const centerXOfImage = elementWidth * 2;
      const centerYOfImage = elementHeight * 2;
      const xZoomPosition = centerXOfImage - maxScale * event.pageX;
      let yZoomPosition = centerYOfImage - maxScale * event.pageY;
      const maxOffset = -1 * (centerYOfImage / 2);
      if (yZoomPosition < maxOffset) {
        yZoomPosition = maxOffset;
      }
      initial.x = initial.x === 0 ? xZoomPosition : 0;
      initial.y = initial.y === 0 ? yZoomPosition : 0;
      initial.scale = initial.scale > 1 ? 1 : maxScale;
      imageElement.classList.remove('pinch-zoom-active');
      transformElement(initial.x, initial.y, initial.scale);
    }

    latestTap = new Date().getTime();
  };

  imageElement.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 2) return;
    // Prevent page scroll
    event.preventDefault();
    imageElement.classList.add('pinch-zoom-active');
    isZooming = true;

    // Calculate where the fingers have started on the X and Y axis
    start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
    start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
    start.distance = distance(event);
    transformElement(initial.x, initial.y, initial.scale);
  });

  imageElement.addEventListener('touchmove', (event) => {
    if (event.touches.length !== 2) return;
    // Prevent page scroll
    event.preventDefault();
    let scale;
    // Safari provides event.scale as two fingers move on the screen
    // For other browsers just calculate the scale manually
    if (event.scale) {
      scale = event.scale;
    } else {
      const deltaDistance = distance(event);
      scale = deltaDistance / start.distance;
    }

    const newScale = Math.min(maxScale, Math.max(1, initial.scale * scale));

    // Calculate how much the fingers have moved on the X and Y axis
    // x2 for accelerated movement
    let deltaX = newScale === 1 ? 0 : ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) * 2;
    let deltaY = newScale === 1 ? 0 : ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) * 2;

    // Add in transform position from previous pan if any
    deltaX += initial.x;
    deltaY += initial.y;

    // Constrain edges to keep image within boundary
    const overlapX = Math.max(0, Math.round((elementWidth * newScale - containerWidth) / 2));
    const overlapY = Math.max(0, Math.round((elementHeight * newScale - containerHeight) / 2));
    deltaX = Math.max(-overlapX, Math.min(overlapX, deltaX));
    deltaY = Math.max(-overlapY, Math.min(overlapY, deltaY));

    // Transform the image to make it grow and move with fingers
    transformElement(deltaX, deltaY, newScale);
    liveValues.x = deltaX;
    liveValues.y = deltaY;
    liveValues.scale = newScale;
  });

  imageElement.addEventListener('touchend', (event) => {
    // Timeout to prevent flickity snapping on pinch end
    setTimeout(() => {
      if (isZooming) {
        initial.scale = liveValues.scale;
        initial.x = liveValues.x;
        initial.y = liveValues.y;
        isZooming = false;
      } else {
        doubleTapZoom(event);
      }
    }, 100);
  });
}

function handleSlideChange(currentSlide) {
  document.querySelectorAll('.product-image img').forEach((img) => {
    const transform = `translate3d(0px, 0px, 0) scale(1)`;
    img.style.transform = transform;
    img.style.WebkitTransform = transform;
    img.style.zIndex = '9999';
    img.classList.remove('pinch-zoom-active');
  });
}

function initPinchZoom() {
  let pinchZooms = {};
  const productImageCarousel = document.querySelector('[data-media-carousel]');
  const productImages = productImageCarousel.querySelectorAll('[data-zoomable-image]');
  if (!productImages.length) return;

  productImages.forEach((wrapper) => {
    pinchZooms[wrapper.dataset.productImageId] = wrapper.querySelector('img');
    pinchZoom(pinchZooms[wrapper.dataset.productImageId]);
  });

  // Flickity (and pinch-zoom) only ever runs below this breakpoint - see product-gallery.js
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const bindFlickityResetOnChange = (attemptsLeft = 20) => {
    if (!mobileQuery.matches) return;

    if (productImageCarousel.flickity) {
      productImageCarousel.flickity.on('change', handleSlideChange);
    } else if (attemptsLeft > 0) {
      // Flickity initializes asynchronously (see product-gallery.js), retry until it's ready
      setTimeout(() => bindFlickityResetOnChange(attemptsLeft - 1), 100);
    }
  };
  bindFlickityResetOnChange();
  mobileQuery.addEventListener('change', () => bindFlickityResetOnChange());
}

window.addEventListener('load', initPinchZoom);
